// Tabs basato su Radix Tabs
import * as RadixTabs from '@radix-ui/react-tabs'
import { cn } from '../../lib/utils'

interface TabItem {
  value: string
  label: string
  icon?: React.ReactNode
  badge?: number
}

interface TabsProps {
  tabs: TabItem[]
  value: string
  onValueChange: (value: string) => void
  children: React.ReactNode
  className?: string
}

export function Tabs({ tabs, value, onValueChange, children, className }: TabsProps) {
  return (
    <RadixTabs.Root value={value} onValueChange={onValueChange} className={className}>
      <RadixTabs.List
        className="flex border-b border-[var(--fc-border)] bg-[var(--fc-surface)]"
        aria-label="Sezioni"
      >
        {tabs.map((tab) => (
          <RadixTabs.Trigger
            key={tab.value}
            value={tab.value}
            className={cn(
              'relative flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition-colors',
              'text-[var(--fc-foreground-muted)] hover:text-[var(--fc-foreground)]',
              'border-b-2 border-transparent -mb-px',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--fc-border-focus)]',
              'data-[state=active]:border-[var(--fc-primary)] data-[state=active]:text-[var(--fc-primary)]'
            )}
          >
            {tab.icon}
            {tab.label}
            {tab.badge !== undefined && tab.badge > 0 && (
              <span className="ml-1 rounded-full bg-[var(--fc-primary)] px-1.5 py-0.5 text-xs text-white leading-none">
                {tab.badge}
              </span>
            )}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {children}
    </RadixTabs.Root>
  )
}

export const TabsContent = RadixTabs.Content
